import React, { useContext } from 'react';
import { Redirect, Route } from 'react-router-dom';

import { UserContext } from '../context/UserContext';

const CipaRoute = props => {
  const { isCipa } = useContext(UserContext);

  if (isCipa) {
    return <Route {...props} />;
  } else if (!isCipa) {
    return <Redirect to='/login' />;
  } else {
    return null;
  }
};

export default CipaRoute;
